var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from 'react';
import { Animated, View } from 'react-native';
import { Circle, Path, Svg } from 'react-native-svg';
import { WHITE } from '../../../../constants';
import { getTestId } from '../../../../utils';
import { DynamicSvg } from '../../../dynamic-svg';
import { getProgressColor } from '../../ProgressStyles';
import { describeArc } from '../../ProgressUtils';
import { getCircularProgressConfig, getProgressStyles } from './CircularProgressStyles';
var CircularProgress = forwardRef((props, ref) => {
  var _a = getCircularProgressConfig(props),
    size = _a.size,
    circum = _a.circum,
    svgProgress = _a.svgProgress,
    cSize = _a.cSize,
    circleProps = _a.circleProps,
    progressBackgroundColor = _a.progressBackgroundColor,
    _a$testID = _a.testID,
    testID = _a$testID === void 0 ? 'CircularProgress' : _a$testID,
    _a$isRadialCircularPr = _a.isRadialCircularProgress,
    isRadialCircularProgress = _a$isRadialCircularPr === void 0 ? false : _a$isRadialCircularPr,
    duration = _a.duration,
    restProps = __rest(_a, ["size", "circum", "svgProgress", "cSize", "circleProps", "progressBackgroundColor", "testID", "isRadialCircularProgress", "duration"]);
  var value = props.value,
    borderColor = props.borderColor,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 1 : _props$strokeWidth,
    iconName = props.iconName,
    iconProps = props.iconProps;
  var radius = size / 2;
  var prevValueRef = useRef(0);
  var _useState = useState(0),
    animatedValue = _useState[0],
    setAnimatedValue = _useState[1];
  var _useState2 = useState([]),
    filledSections = _useState2[0],
    setFilledSections = _useState2[1];
  var _useState3 = useState(false),
    isComplete = _useState3[0],
    setIsComplete = _useState3[1];
  var iconOpacity = useRef(new Animated.Value(0)).current;
  var progressStyles = getProgressStyles();
  useEffect(() => {
    var frameId;
    var startTime = performance.now();
    var prevValue = prevValueRef.current;
    var animate = timestamp => {
      var elapsed = timestamp - startTime;
      var progress = Math.min(prevValue + elapsed / duration * (value - prevValue), value);
      setAnimatedValue(progress);
      if (progress < value) {
        frameId = requestAnimationFrame(animate);
      } else {
        prevValueRef.current = value;
        setFilledSections(prev => [...prev, value]);
        if (value === 100) {
          setIsComplete(true);
          Animated.timing(iconOpacity, {
            toValue: 1,
            duration: 500,
            delay: 500,
            useNativeDriver: true
          }).start();
        }
      }
    };
    frameId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frameId);
  }, [value]);
  if (isRadialCircularProgress) {
    return _jsxs(View, Object.assign({
      style: progressStyles.container
    }, {
      children: [_jsxs(Svg, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 " + size + " " + size
      }, {
        children: [_jsx(Circle, {
          cx: radius,
          cy: radius,
          r: radius - strokeWidth / 2,
          stroke: borderColor,
          strokeWidth: strokeWidth,
          fill: isComplete ? progressBackgroundColor : WHITE
        }), filledSections.map((progress, index) => _jsx(Path, {
          d: describeArc(radius, radius, radius - strokeWidth, 0, progress / 100 * 360),
          fill: progressBackgroundColor
        }, index)), !isComplete && animatedValue > 0 && _jsx(Path, {
          d: describeArc(radius, radius, radius - strokeWidth, 0, animatedValue / 100 * 360),
          fill: progressBackgroundColor
        })]
      })), isComplete && _jsx(Animated.View, Object.assign({
        style: {
          position: 'absolute',
          opacity: iconOpacity
        }
      }, {
        children: _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          fontSize: 14,
          color: WHITE
        }, iconProps))
      }))]
    }));
  }
  return _jsxs(Svg, Object.assign({
    ref: ref,
    width: size,
    height: size
  }, restProps, getTestId(testID), {
    children: [_jsx(Circle, Object.assign({
      stroke: progressBackgroundColor
    }, circleProps, getTestId(testID, 'progressCircle'))), _jsx(Circle, Object.assign({}, circleProps, {
      fill: "none",
      stroke: getProgressColor(props),
      strokeDasharray: circum + " " + circum,
      strokeDashoffset: circum * svgProgress / 100,
      transform: "rotate(-90, " + cSize + ", " + cSize + ")"
    }, getTestId(testID, 'backgroundCircle')))]
  }));
});
export default CircularProgress;